import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React from 'react';

function GroupConfirmatiomModel({
  open, TransitionComponent, keepMounted, onClose, fullWidth, selectedGroup, disableOrEnableGroup, handleCloseDialog,
}) {
  return (
    <Dialog
      open={open}
      TransitionComponent={TransitionComponent}
      keepMounted={keepMounted}
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={fullWidth}
    >
      <DialogTitle component="div">
        <Typography color="textPrimary" align="center" variant="h4">
          Group:
          {' '}
          {selectedGroup.GroupName}
        </Typography>
      </DialogTitle>
      <Divider>
        {selectedGroup.Status === 1
          ? <Chip color="primary" label="Note: Group can not be disabled if user exist in this Group." size="small" />
          : <Chip color="primary" label="Please confirm" size="small" />}

      </Divider>
      <DialogContent data-testid="confirmation-dialog">
        <DialogContentText id="alert-dialog-slide-description" component="div">
          <Typography align="center" color="textSecondary" variant="h5">
            Are you sure you wants to
            {' '}
            {selectedGroup.Status === 1 ? 'Disable' : 'Enable'}
            {' '}
            this group?
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button sx={{ cursor: 'pointer' }} variant="outlined" color="info" onClick={handleCloseDialog}>Cancel</Button>
        <Button
          sx={{ cursor: 'pointer' }}
          variant="outlined"
          color="success"
          onClick={disableOrEnableGroup}
        >
          {selectedGroup.Status === 1 ? 'Disable' : 'Enable'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GroupConfirmatiomModel;
